import React from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import VehicleSnapshot from './VehicleSnapshot'
import GuessFeedbackPulse from './GuessFeedbackPulse'
import type { GuessFeedback, QualificationChoice, SoldVehicle } from '../types'
import PriceBillboard from './PriceBillboard'
import NeonProgress from './NeonProgress'
import { buzzerButton, TV_COLORS } from '../designSystem'
import PresenterPrompt from './PresenterPrompt'

type QualificationPhaseProps = {
  vehicle: SoldVehicle | null
  referencePrice: number | null
  remainingMs: number
  totalDurationMs: number
  successes: number
  required: number
  onGuess: (choice: QualificationChoice) => void
  feedback?: GuessFeedback | null
}

const QualificationPhase = ({
  vehicle,
  referencePrice,
  remainingMs,
  totalDurationMs,
  successes,
  required,
  onGuess,
  feedback,
}: QualificationPhaseProps) => {
  const progress = Math.max(0, Math.min(100, (remainingMs / totalDurationMs) * 100))

  return (
    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
      <VehicleSnapshot vehicle={vehicle} />

      <PriceBillboard
        label="Proposition actuelle"
        value={referencePrice ?? null}
      />

      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{ mb: 1 }}
      >
        <Typography
          variant="body2"
          sx={{ fontFamily: 'Montserrat', color: TV_COLORS.cyan }}
        >
          Réponses justes : {successes}/{required}
        </Typography>
      </Stack>

      <NeonProgress value={progress} />

      <PresenterPrompt message="Alors… plus ou moins ? Fais vibrer le buzzer !" />

      <GuessFeedbackPulse feedback={feedback} />

      <Stack
        direction="row"
        spacing={1}
        sx={{ mb: 2 }}
      >
        <Button
          fullWidth
          variant="contained"
          sx={buzzerButton('higher')}
          onClick={() => onGuess('higher')}
        >
          C’est plus
        </Button>
        <Button
          fullWidth
          variant="contained"
          sx={buzzerButton('lower')}
          onClick={() => onGuess('lower')}
        >
          C’est moins
        </Button>
      </Stack>
    </Box>
  )
}

export default QualificationPhase
